import { render, staticRenderFns } from "./secondary.vue?vue&type=template&id=e4b18f4e"
import script from "./secondary.vue?vue&type=script&lang=js"
export * from "./secondary.vue?vue&type=script&lang=js"
import style0 from "./secondary.vue?vue&type=style&index=0&id=e4b18f4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports